export function validateMinMax(value: any, min: number, max: number): boolean {
     if (value && Number(value)) {
         return value >= min && value <= max;
     } 
     return false;
 }